import * as z from "zod";

export const createMobileUploadToken = {
  name: "createMobileUploadToken" as const,
  input: z.object({ widgetId: z.string() }),
  output: z.object({ token: z.string(), expiresAt: z.date() }),
};
